// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact-hashed__contact__j9Kxf","contact__icon":"Contact-hashed__contact__icon__KxA--","contact__address":"Contact-hashed__contact__address__2KVFB"};